import resolveColor from './ColorResolver';
import { resolveResponsiveFactorSize } from './ComposedResolvers';
export function getResponsiveFactorSizeResolver(theme, sizesDefinition, screenWidth) {
    return function (responsiveValue) { return resolveResponsiveFactorSize(theme, screenWidth, sizesDefinition, responsiveValue); };
}
export function getColorResolver(theme, screenWidth) {
    return function (color) { return resolveColor(theme, screenWidth, color); };
}
//# sourceMappingURL=CurryingResolvers.js.map